/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { investmentNeedRoundHistoryDtoSchema } from "./investmentNeedRoundHistoryDtoSchema.ts";
import { z } from "zod/v4";

export const investmentNeedComparableDtoSchema = z.object({
  name: z.optional(z.string()),
  status: z.string().nullish(),
  acquisitionNote: z.string().nullish(),
  linkText: z.optional(z.string()),
  linkUrl: z.optional(z.string()),
  muted: z.optional(z.boolean()),
  totalFunding: z.optional(z.string()),
  rounds: z.optional(z.string()),
  investors: z.optional(z.string()),
  latestRound: z.optional(z.string()),
  latestAmount: z.optional(z.string()),
  get history() {
    return z.array(investmentNeedRoundHistoryDtoSchema).optional();
  },
});
